import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Modal as ReactstrapModal,
    ModalBody,
} from 'reactstrap';

class CancelBookingRequestModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.isOpen,
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleModal: PropTypes.func.isRequired,
    };

    static defaultProps = {
        isOpen: false,
    };

    render() {
        const { isOpen } = this.props;

        return (
            <ReactstrapModal
                isOpen={isOpen}
                className="cancel-booking-request-modal"
                backdrop={true}
                zIndex={1100}
            >
                <ModalBody>
                    <div className="flex flex-col justify-center p-3 text-center">
                        <p>
                            A cancellation request has been sent to customer service.
                        </p>
                        <p>
                            We will update you once the provider confirms the cancellation.
                        </p>
                    </div>
                    <div className='flex justify-center'>
                        <Button color="primary" onClick={() => this.props.toggleModal()}>
                            OK
                        </Button>
                    </div>
                </ModalBody>
            </ReactstrapModal>
        );
    }
}

export default CancelBookingRequestModal;



// WEBPACK FOOTER //
// ./src/components/CommonModals/CancelBookingRequestModal.js